import { render, staticRenderFns } from "./SpaceCover.vue?vue&type=template&id=7e471e66&scoped=true"
import script from "./SpaceCover.vue?vue&type=script&lang=js"
export * from "./SpaceCover.vue?vue&type=script&lang=js"
import style0 from "./SpaceCover.vue?vue&type=style&index=0&id=7e471e66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e471e66",
  null
  
)

export default component.exports